import { ApiServiceV2 } from '@sunrise-upc/ajax-lib';
import { v4 as generateUID } from 'uuid';
import { APIResourceConstants } from '../api-constants';
// import endPoints from '@/utils/endpoints-config2';
import axios from 'axios';
import { LineTableBasicPropConfig } from '../LineTableBasicPropConfig';
import { useMemo } from 'react';
class multiItemAccessoryService {
  apiServiceInstance: ApiServiceV2;
  // productAPIBasicAuth: string;
  constructor() {
    this.apiServiceInstance = ApiServiceV2?.getApiServiceInstance();
    // this.productAPIBasicAuth = endPoints?.getAuthDetials(APIResourceConstants?.THREE_SCALE_API_KEY);
  }

  //for getting all recommended Accessory product Ids
  getRecommendedAccessoryData = (cartId: string, recommendationType: any) => {
    const source = axios.CancelToken.source();
    const options = this.apiServiceInstance?.getOption();
    options.cancelToken = source.token;
    options.headers = {
      ...options?.headers,
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants?.X_SUN_CHAL,
    };
    // if (endPoints?.isDevelopment()) {
    //   options.headers.Authorization = this.productAPIBasicAuth;
    // } else {
    //   delete options?.headers?.Authorization;
    // }
    const cartBaseEndpoint: string = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
    options.params = {};
    options.cancelToken = source?.token;
    const URL = cartBaseEndpoint + APIResourceConstants?.RECOMMENDED_ACCESSORIES + `?cartId=${cartId}` + `&recommendationType=${recommendationType}`;
    return this.apiServiceInstance
      ?.get(URL)
      .then((res) => {
        return res?.data;
      })
      .catch((error: any) => {
        //returning error on 404
        if (error.response) {
          if (error.response.status === 404) {
            return [];
          }
          else {
            throw Error('Promise failed to fetch recommended accessories due to Technical Error!');
          }
        } else {
          throw Error('Promise failed to fetch recommended accessories due to Technical Error!');
        }
      });
  };
}

const multiItemAccessoryServices: multiItemAccessoryService = new multiItemAccessoryService();

export default multiItemAccessoryServices;